export default __webpack_public_path__ + "2c0b6877f9c82f3ac8689d1944b5514d.png";